import { render } from "./CkEditorField.vue?vue&type=template&id=4139bbd6"
import script from "./CkEditorField.vue?vue&type=script&lang=js"
export * from "./CkEditorField.vue?vue&type=script&lang=js"

import "./CkEditorField.vue?vue&type=style&index=0&id=4139bbd6&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CkEditorField.vue"]])

export default __exports__